import { render, staticRenderFns } from "./PrestadoresIndisponiveisAoIntercambioFiltro.vue?vue&type=template&id=55d13ca4"
import script from "./PrestadoresIndisponiveisAoIntercambioFiltro.vue?vue&type=script&lang=js"
export * from "./PrestadoresIndisponiveisAoIntercambioFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports